module.exports = __webpack_public_path__ + "img/23-oldster.829d30af.svg";